/* eslint-disable no-underscore-dangle */
import React from 'react';
import CookieConsent, { getCookieConsentValue } from 'react-cookie-consent';
import { useIntl } from 'gatsby-plugin-react-intl';

import { Box } from '@mui/material';
import { Link } from './theme';

function CookieConsentBar() {
  const intl = useIntl();

  if (getCookieConsentValue('kki-consent') === 'true') {
    if (window._paq) {
      window._paq.push(['setConsentGiven']);
    }
  }

  return (
    <Box
      sx={{
        '& .kki-btn-accept-consent:hover, & .kki-btn-accept-consent:focus': {
          backgroundColor: '#a10047 !important',
          outline: 'none',
        },
        '& .kki-btn-decline-consent:hover, & .kki-btn-decline-consent:focus': {
          color: '#d82772 !important',
        },
      }}
    >
      <CookieConsent
        location="bottom"
        buttonText={intl.formatMessage({ id: 'cookie.buttonAgree' })}
        cookieName="kki-consent"
        style={{
          width: '600px',
          maxWidth: 'calc(100vw - 40px)',
          height: '66px',
          margin: '0 auto 10px',
          right: '0',
          alignItems: 'center',
          padding: '0 10px 0 34px',
          borderRadius: '33px',
          backgroundColor: '#121212',
          fontSize: '16px',
        }}
        buttonStyle={{
          backgroundColor: '#d82772',
          color: '#fff',
          font: 'inherit',
          fontSize: '14px',
          lineHeight: '1em',
          width: '71px',
          height: '46px',
          margin: '0 0 0 24px',
          padding: '15px 26px',
          borderRadius: '23px',
        }}
        declineButtonStyle={{
          background: 'none',
          font: 'inherit',
          margin: '0',
          padding: '0',
        }}
        contentStyle={{
          display: 'flex',
          margin: '15px',
          flex: '1',
          justifyContent: 'space-between',
        }}
        expires={150}
        enableDeclineButton
        declineButtonText={intl.formatMessage({ id: 'cookie.buttonDecline' })}
        onAccept={() => {
          if (window._paq) {
            window._paq.push(['setConsentGiven']);
          }
        }}
        ariaAcceptLabel={intl.formatMessage({ id: 'cookie.ariaAgree' })}
        ariaDeclineLabel={intl.formatMessage({ id: 'cookie.ariaDecline' })}
        buttonClasses="kki-btn-accept-consent"
        declineButtonClasses="kki-btn-decline-consent"
      >
        <span>{intl.formatMessage({ id: 'cookie.message' })}</span>
        <Link variant="inherit" underline="true" color="inherit" to="/privacy">
          {intl.formatMessage({ id: 'cookie.privacyLink' })}
        </Link>
      </CookieConsent>
    </Box>
  );
}

export default CookieConsentBar;
